/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Bluefin/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromHelpers from './helpers.js'
import Radial from 'DesignSystem/Radial/index'
import React from 'react'
import bluefinPng from "./bluefin.png"
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'



/** @type {import('Simple/types.js').View} */
export default function Bluefin({
  children,
  viewPath = "/App/Account/Content/Settings/Content/PaymentProviders/AddAction/Content/Bluefin"
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({})
let onClick = fromHelpers.useOnClick({
  children,
  viewPath
  
})
let addProviderProviderValueData = fromData.useDataValue({ viewPath,
context: 'add_provider',
path: 'provider',
})
let constantData = 'bluefin'
let aggregateData = fromAggregate.equals(addProviderProviderValueData, constantData)
  return (<React.Fragment
>
<button
  data-testid="Bluefin.Horizontal"
  data-view-path={viewPath}
 {...isHoveredBind}
 onClick={onClick}
 className={`views-block ${styles.Horizontal}`}
>
<Radial
  viewPath={`${viewPath}/Radial`}
 data="add_provider.provider"
 data="'bluefin'"
 aggregate="/Data/aggregate.js equals"
 isSelected={aggregateData}
 marginRight={0}
 paddingRight={0}
/>
<img
  data-testid="Bluefin.Image"
  data-view-path={viewPath}
 alt={""}
 src={bluefinPng}
 className={`views-block ${styles.Image}`}
/>
</button>
{children}
</React.Fragment>)
}